import { dayCalendarStore } from 'entities/calendar/model/day-calendar.store';
import { MiniCalendar } from 'features/index';
import { ICalendarDate } from 'entities/calendar/model/calendar-date';
import React from 'react';
import * as dateFns from 'date-fns';
import { ru } from 'date-fns/locale';
import styles from './step-date-confirm.module.scss';

export const StepDateConfirm: React.FC = () => {
  const selectedDate = dayCalendarStore.getSelectedDateAsDate;
  const formattedDate = dateFns.format(selectedDate, 'dd MMMM yyyy', {
    locale: ru,
  });

  const selectedDateHandler = (date: ICalendarDate) => {
    dayCalendarStore.selectedDate = date;
  };

  return (
    <div className={styles.date__container}>
      <div className={styles.date__text}>Выбранная дата:</div>
      <div className={styles.date__value}>{formattedDate} г.</div>
      <div className={styles.date__calendar}>
        <MiniCalendar
          selectedDateHandler={selectedDateHandler}
          shouldNavigate={false}
          onlyWorkdaysClickable={true}
          compact
        />
      </div>
    </div>
  );
};
